// @ts-nocheck
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import { useAuthStore } from "src/components/main/authStore";
import {
    mimeTypeMap, 
    getDatefromWeekNum, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredForms, 
    week, 
    weekDay, 
}){
    const user = useAuthStore(state => state.user);
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const handleExport = () => {
        setShowLoader(true);
        //--------------------------------------------------
        const mainData = filteredForms.map(c => ({
            ...c[week].form[weekDay], 
            firstName: c.firstName,
            lastName: c.lastName
        })).filter(c => c.working);
        if(!mainData.length){
            window.alert("Nobody submitted.");
            return;
        }
        const workbook = new Excel.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet();
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 18;
   
        const rows = mainData.map(d => {
            return [
            d.lastName, // 1
            d.firstName, // 2
            d.morning?"Yes":"No", // 3
            d.afternoon?"Yes":"No", // 4
            d.doOT, // 5
            d.otDate && d.otTime ? d.otDate + " " + d.otTime : "", // 6
        ]});
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            headerRow: true,
            style: {
                theme: "TableStyleMedium9",
                showRowStripes: true,
            },
            columns: [
                {name: "Last Name", filterButton: true}, // 1
                {name: "First Name", filterButton: true}, // 2
                {name: "Morning", filterButton: true}, // 3
                {name: "Afternoon", filterButton: true}, // 4
                {name: "OT", filterButton: true}, // 5
                {name: "End Time", filterButton: true}, // 6
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //--------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Check-In ${getDatefromWeekNum(week, weekDay).slice(5)}.xlsx`);
            setShowLoader(false);
        });
        //--------------------------------------------------
    }
    //--------------------------------------------------------------------------------------------
    return(
        <button type = "button" className = "btn btn-primary" onClick = {() => handleExport()}>Export</button>
    )
}
